<template>
  <div class="music-player-wrap">
    <div style="width: 1240px;">
      <!-- <el-button @click="$router.push('/')" icon="el-icon-arrow-left" type="text" style="font-size: 20px;">回到首页</el-button> -->
      <section class="my-title-cn">正版音乐</section>
      <div class="my-title-en">试听</div>
      <div style="display:flex;justify-content:space-between;">
        <div style="width:688px;">
          <div class="table-head">
            <span style="width:90px;text-align:center;" class="center-text">序号</span>
            <span style="flex:1;" class="center-text">歌曲名称</span>
            <span style="width:100px;" class="center-text">歌手</span>
            <span style="width:88px;" class="center-text">作曲</span>
            <span style="width:50px;" class="center-text"></span>
          </div>
          <ul class="music-list">
            <li
              v-for="(item, index) in list"
              :key="index"
              style="display:flex;height:48px;line-height:48px;"
              :class="{ selected: (item || {}).musicUrl === (currentMusic || {}).musicUrl }"
            >
              <span style="width:90px;text-align:center;" class="center-text">{{ item.id || index + 1 }}</span>
              <span style="flex:1;" class="center-text">{{ item.musicName }}</span>
              <span style="width:100px;" class="center-text" :title="item.singer">{{ item.singer }}</span>
              <span style="width:88px;" class="center-text" :title="item.composer">{{ item.composer }}</span>
              <span style="width:50px;" class="center-text play-icon">
                <img
                  v-if="isPlaying && (currentMusic || {}).musicUrl === (item || {}).musicUrl"
                  width="24"
                  style="vertical-align:middle;cursor:pointer;"
                  src="@/assets/pause.png"
                  @click="toggle(index)"
                />
                <img v-else width="24" style="vertical-align:middle;cursor:pointer;" src="@/assets/play.png" @click="toggle(index)" />
              </span>
            </li>
          </ul>

          <el-pagination background layout="prev, pager, next" :total="total" @size-change="changeSize" @current-change="changeCurrentPage" style="margin-top:10px;"></el-pagination>
        </div>
        <div style="width:505px;background: #F4F6FA;height:586px;color:#333;min-height:630px;position:relative;" v-if="currentMusic">
          <div style="font-size:18px;position:absolute;top:20px;left:34px;">当前播放</div>
          <div style="display:flex;justify-content:center;margin:26px 0;">
            <div class="music-cover">
              <img style="border-radius:50%;width:144px;height:144px;" :src="this.currentMusic.cover" />
            </div>
          </div>
          <div style="display:flex;flex-direction:column;align-items:center;text-align:center;">
            <p style="margin:6px 0;width:500px;font-size:16px;">{{ this.currentMusic.musicName }}</p>
            <p style="margin:6px 0;width:240px;font-size:14px;color:#666;">{{ this.currentMusic.singer }}</p>
            <p style="margin:6px 0;width:240px;font-size:12px;color:#999;">{{ `${secondToTime(playStat.playedTime)} / ${secondToTime(playStat.duration)}` }}</p>
          </div>

          <player-lrc :current-music="currentMusic" :play-stat="playStat"></player-lrc>
        </div>
      </div>
    </div>
    <audio ref="audio"></audio>
  </div>
</template>

<script>
import PlayerLrc from './components/PlayerLrc.vue'

export default {
  components: {
    PlayerLrc
  },
  props: {},
  data() {
    return {
      list: [],
      total: 100,
      currentMusic: null,
      isPlaying: false,
      playStat: {
        duration: 0,
        loadedTime: 0,
        playedTime: 0
      }
    }
  },
  async created() {
    await this.getData()
    this.currentMusic = this.list[0]
    this.initAudio()
  },
  mounted() {},
  methods: {
    async getData(page, pageSize) {
      let {
        data: { list, total }
      } = await this.$api.axiosGetPlayerList(page, pageSize)

      this.total = total

      this.list = list.map(v => {
        ;['cover', 'lyricUrl', 'musicUrl'].forEach(item => {
          v[item] = v[item].startsWith('http') ? v[item] : 'https://mxcdn.muccyapi.com/' + v[item]
        })

        return v
      })
      console.log('list ======= ', list)
    },
    initAudio() {
      if (this.currentMusic) {
        this.audio.src = this.currentMusic.src || this.currentMusic.musicUrl
      }

      this.audio.addEventListener('play', this.onAudioPlay)
      this.audio.addEventListener('pause', this.onAudioPause)
      this.audio.addEventListener('seeking', this.onAudioSeeking)
      this.audio.addEventListener('seeked', this.onAudioSeeked)
      this.audio.addEventListener('timeupdate', this.onAudioTimeUpdate)
      this.audio.addEventListener('durationchange', this.onAudioDurationChange)
    },

    // play/pause
    toggle(index) {
      if (this.currentMusic.musicUrl === this.list[index].musicUrl) {
        if (!this.audio.paused) {
          this.audio.pause()
        } else {
          this.audio.play()
        }
      } else {
        this.currentMusic = this.list[index]
        this.initAudio()
        this.audio.play()
      }
    },
    onAudioPlay() {
      this.isPlaying = true
    },
    onAudioPause() {
      this.isPlaying = false
    },
    onAudioTimeUpdate() {
      this.playStat.playedTime = this.audio.currentTime
      // console.log('playedTime ==== ', this.playStat.playedTime)
    },
    onAudioSeeking() {
      this.playStat.playedTime = this.audio.currentTime
    },
    onAudioSeeked() {
      this.playStat.playedTime = this.audio.currentTime
    },
    onAudioDurationChange() {
      if (this.audio.duration !== 1) {
        this.playStat.duration = this.audio.duration
      }
    },
    secondToTime(second) {
      if (isNaN(second)) {
        return '00:00'
      }
      const pad0 = num => {
        return num < 10 ? '0' + num : '' + num
      }

      const min = Math.trunc(second / 60)
      const sec = Math.trunc(second - min * 60)
      const hours = Math.trunc(min / 60)
      const minAdjust = Math.trunc(second / 60 - 60 * Math.trunc(second / 60 / 60))
      return second >= 3600
        ? pad0(hours) + ':' + pad0(minAdjust) + ':' + pad0(sec)
        : pad0(min) + ':' + pad0(sec)
    },
    changeCurrentPage(page) {
      this.getData(page)
    },
    changeSize(pageSize) {
      this.getData(1, pageSize)
    }
  },
  computed: {
    // alias for $refs.audio
    audio() {
      return this.$refs.audio
    }
  },
  watch: {}
}
</script>

<style scoped lang="less">
.music-player-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  padding: 100px 20px;
  height: 1080px;
  .head {
    margin: 20px 0 0;
    font-size: 48px;
    font-weight: 400;
  }
  .my-title-cn {
    font-size: 40px;
    color: #333333;
    line-height: 70px;
  }
  .my-title-en {
    margin: 0 0 50px;
    font-size: 22px;
    color: rgba(#58627c, 0.5);
  }
  .sub-head {
    font-size: 22px;
    color: #58627c;
    opacity: 0.5;
    margin: 10px 0;
  }
  .table-head {
    height: 64px;
    background: #e1e4ea;
    line-height: 64px;
    font-size: 18px;
    color: #333333;
    display: flex;
  }
  .music-list {
    height: 550px;
    overflow: auto;
    li:nth-child(even) {
      background-color: #f4f6fa;
    }
    li:hover {
      .play-icon {
        visibility: visible;
      }
    }
  }
  .center-text {
    display: inline-block;
    // text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 10px;
  }

  /deep/.el-pagination {
    font-weight: 400;
    .active {
      background-color: #4b85ff !important;
    }
  }
  .play-icon {
    visibility: hidden;
  }
  .selected {
    // background-color: #ccc !important;
    color: #4b85ff;
    .play-icon {
      visibility: visible;
    }
  }
  .music-cover {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 254px;
    height: 254px;
    background: center / contain no-repeat url(~@/assets/music-cover.png);
  }
}
</style>
